import axios from "../../service";
import md5 from "md5";
import alert from "@/_helpers/alert";
import { AuthService } from "../resources";
// import _ from "underscore"

export const state = {
  currentUser: {},
  userCurrent: {},
  accessLevel: {},
  storeRegister: {
    name: "",
    telephone: "",
    password: "",
    ref: "",
    otp: ""
  },
  version: false,
  isPageRefreshed: null,
  tabStatusTest: true
};

export const mutations = {
  SET_STATUS_TAB(state, newValue) {
    state.tabStatusTest = newValue;
  },

  SET_IS_REFRESH(state, newValue) {
    state.isPageRefreshed = newValue;
  },

  SET_ACCESS_LEVEL(state, newValue) {
    state.accessLevel = newValue;
  },

  SET_VERSION(state, newValue) {
    state.version = newValue;
  },

  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
    setDefaultAuthHeaders(state);
    saveState("auth.currentUser", newValue);
  },
  SET_CONFIRM_OTP(state, newValue) {
    state.storeRegister = newValue;
  },
  UPDATE_USER_IMAGE(state, newValue) {
    let user = state.currentUser.user;
    user.profile_pic = newValue.url;
    user.name = newValue.name;
    Object.assign(state.currentUser.user, user);
  },
  UPDATE_USER_NAME(state, newValue) {
    let user = state.currentUser.user;
    user.name = newValue.name;
    Object.assign(state.currentUser.user, user);
  },
  UPDATE_USER_CREDIT(state, newValue) {
    let user = state.currentUser.user;
    user.credit = newValue.credit;
    user.bonus = newValue.bonus;
    Object.assign(state.currentUser.user, user);
  },

  SET_CURRENT_USER_DEFAULT(state, newValue) {
    state.userCurrent = newValue;
  }
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser;
  },
  dataConfirm(state) {
    return state.storeRegister;
  }
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state);
    // dispatch("validate");
  },

  // Logs in the current user.
  // async loginNormal({ commit, dispatch, getters }, data) {
  //     try {
  //         if (getters.loggedIn) return dispatch("validate");
  //         const date = Date.now();
  //         let resp = await axios.post(`/user/login/${date}`, {...data }, { headers: generateToken(date) });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //         if (typeof resp.data[0].ref !== "undefined") {
  //             return { status: true, otp: true, data: resp.data[0] };
  //         }
  //         commit("SET_CURRENT_USER", {
  //             access_token: resp.data[0].access_token,
  //             user: resp.data[0].user,
  //         });
  //         commit("SET_CURRENT_USER_DEFAULT", {
  //             access_token: resp.data[0].access_token,
  //             user: resp.data[0].user,
  //         });
  //         return { status: true, otp: false, child_account: resp.data[0].child_account };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },

  async loginSystem({ commit, dispatch, getters }, data) {
    let resp = await AuthService.apiCreateloginSystem(data);
    return { status: true, ...resp.data };
  },

  async getAccountShop({ commit, dispatch, getters }, data) {
    let resp = await AuthService.apiGetAccountShop(data);
    return { status: true, ...resp };
  },

  async selectShop({ commit, dispatch, getters }, partnerId) {
    try {
      let resp = await AuthService.apiCreateselectShop(partnerId);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async InitPermission({ commit, dispatch, getters }, partnerId) {
    try {
      let resp = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/init`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(success => {
          return success;
        })
        .catch(err => {
          console.error(err.message, "message-Login");
          alert.error(err.message);
          return err.message;
        });
      return resp?.data;
      if (resp.status === 200) {
        return resp.data;
      } else {
        return false;
      }
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  

  async register({ commit, dispatch, getters }, data) {
    try {
      let resp = await AuthService.apiCreateregister(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async reSendOtp({ commit, dispatch, getters }, telephone) {
    try {
      let resp = await AuthService.apiCreatereSendOtp(telephone);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async confirmOtp({ commit, dispatch, getters }, data) {
    try {
      let resp = await AuthService.apiCreateConfirmOtp(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async forgetSendEmailOTP({ commit }, phone) {
    try {
      let resp = await AuthService.apiCreateforgetSendEmailOTP(phone);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async forgetVerifyOtp({ commit }, data) {
    try {
      let resp = await AuthService.apiCreateforgetVerifyOtp(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async confirmChangePassword({ commit }, data) {
    try {
      let resp = await AuthService.apiCreateconfirmChangePassword(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async lotOutAPI({ commit }, data) {
    try {
      let resp = await AuthService.apiCreatelotOut(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async getAccessLevel({ commit }, data) {
    try {
      let resp = await AuthService.apiGetAccessLevel();
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    // if (getters.loggedIn) return dispatch("validate");
    // return getFirebaseBackend().forgetPassword(email).then((response) => {
    //     const message = response.data
    //     return message
    // });
  },

  async checkKeyInvite({ commit }, key) {
    try {
      let resp = await AuthService.apiGetcheckKeyInvite(key);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async useKeyInvite({ commit }, key) {
    try {
      let resp = await AuthService.apiCreateuseKeyInvite(key);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async sendSupportRequest({ commit }, statusRequest) {
    try {
      let resp = await AuthService.apiEditsendSupportRequest(statusRequest);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async getGraphParcelProvince({ commit }, data) {
    try {
      let resp = await AuthService.apiGetGraphParcelProvince(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async getGraphWeightSize({ commit }, data) {
    try {
      let resp = await AuthService.apiGetGraphWeightSize(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  resetAuth({ commit }) {
    commit("SET_CURRENT_USER", null);
    resetAuthAndRedirect();
  }
};

// ===
// Private helpers
// ===

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state));
}

function removeState(key) {
  window.localStorage.removeItem("vuex");
  window.localStorage.removeItem(key);
}

function setDefaultAuthHeaders(state) {
  if (typeof state.currentUser !== "undefined" && state.currentUser !== null)
    axios.defaults.headers.common["Authorization"] = `Bearer Token:${state.currentUser.access_token}`;
}

function resetAuthAndRedirect(redirect = true) {
  localStorage.removeItem("auth.currentUser");
  localStorage.removeItem("vuex");

  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("parent");
  localStorage.removeItem("wallet");
  localStorage.removeItem("permission");
  
  let query = "";

  if (!["/", "/login", "/logout"].includes(window.location.pathname) && redirect) {
    query = "?redirect=" + window.location.pathname;
  }

  window.location.href = "/login" + query;
}


// function generateToken(date) {
//   const headers = {
//     Authorization: "Token:" + md5(process.env.VUE_APP_GLOBAL_SALT + date)
//   };
//   return headers;
// }
